export interface PropValidation {
  property: string,
  validationProp: string,
  operator: number,
}